import { useTranslation } from "react-i18next";

const useMenuItems = () => {
  const { t } = useTranslation(); // Initialize translation hook

  return [
    {
      type: "HASHMENU",
      id: 1,
      label: t("menu.users"),
      icon: "ph-duotone ph-users",
      link: "/users",
    },
    {
      type: "HASHMENU",
      id: 2,
      label: t("menu.customers"),
      icon: "ph-duotone ph-user-list",
      submenu: [
        {
          id: 21,
          label: t("menu.customerList"),
          link: "/customers",
        },
        {
          id: 22,
          label: t("menu.customerTypes"),
          link: "/customer-types",
        },
      ],
    },
    {
      type: "HASHMENU",
      id: 3,
      label: t("menu.locations"),
      icon: "ph-duotone ph-map-pin",
      link: "/locations",
    },
    {
      type: "HASHMENU",
      id: 4,
      label: t("menu.floors"),
      icon: "ph-duotone ph-rows",
      link: "/floors",
    },
    // {
    //   type: "HASHMENU",
    //   id: 5,
    //   label: t("menu.floorTypes"),
    //   icon: "ph-duotone ph-stack-simple",
    //   link: "/floor-types",
    // },
    {
      type: "HASHMENU",
      id: 6,
      label: t("menu.flats"),
      icon: "ph-duotone ph-buildings",
      link: "/flats",
    },
    {
      type: "HASHMENU",
      id: 7,
      label: t("menu.rooms"),
      icon: "ph-duotone ph-door",
      link: "/room-names",
      // submenu: [
      //   {
      //     id: 16,
      //     label: t("menu.roomItems"),
      //     link: "/rooms",
      //   },
      //   {
      //     id: 17,
      //     label: t("menu.roomNames"),
      //
      //   },
      // ],
    },
    {
      type: "HASHMENU",
      id: 9,
      label: t("menu.materials"),
      icon: "ph-duotone ph-package",
      submenu: [
        {
          id: 91,
          label: t("menu.materialItems"),
          link: "/materials",
        },
        {
          id: 92,
          label: t("menu.materialTypes"),
          link: "/material-types",
        },
        {
          id: 93,
          label: t("menu.flatMaterials"),
          link: "/flat-materials",
        },
      ],
    },
    // {
    //   type: "HASHMENU",
    //   id: 10,
    //   label: t("menu.skirtingBoards"),
    //   icon: "ph-duotone ph-frame-corners",
    //   link: "/skirting-boards",
    // },
    {
      type: "HASHMENU",
      id: 15,
      label: t("menu.specialConditions"),
      icon: "ph-duotone ph-star",
      link: "/special-conditions",
    },
    {
      type: "HASHMENU",
      id: 16,
      label: t("menu.suppliers"),
      icon: "ph-duotone ph-truck",
      link: "/suppliers",
    },
    {
      type: "HASHMENU",
      id: 11,
      label: t("menu.jobs"),
      icon: "ph-duotone ph-briefcase-metal",
      submenu: [
        {
          id: 111,
          label: t("menu.jobList"),
          link: "/jobs",
        },
        {
          id: 112,
          label: t("menu.jobCategories"),
          link: "/job-categories",
        },
        {
          id: 113,
          label: t("menu.jobPackages"),
          link: "/job-packages",
        },
        {
          id: 114,
          label: t("menu.flatJobs"),
          link: "/flat-jobs",
        },
      ],
    },
    {
      type: "HASHMENU",
      id: 18,
      label: t("menu.offerConditionNames"),
      icon: "ph-duotone ph-percent",
      link: "/offer-condition-names",
    },
    {
      type: "HASHMENU",
      id: 14,
      label: t("menu.templateIntro"),
      icon: "ph-duotone ph-presentation-chart",
      link: "/template-intro",
    },
    {
      type: "HASHMENU",
      id: 94,
      label: t("menu.templateAppendix"),
      icon: "ph-duotone ph-paperclip",
      link: "/template-appendix",
    },
    {
      type: "HASHMENU",
      id: 20,
      label: t("menu.documentTemplates"),
      icon: "ph-duotone ph-file-text",
      link: "/document-templates",
    },
    // {
    //   type: "HASHMENU",
    //   id: 15,
    //   label: t("pageTitles.settings"),
    //   icon: "ph-duotone ph-gear",
    //   link: "/settings",
    // },
  ];
};

export { useMenuItems };
